<div class="d-flex flex-column w-100 h-100"
     khA11yCarousel
  [khA11yLabel]="'A11Y_CAROUSEL.CAROUSEL' | translate"
     (mouseover)="setAutoplayEnabled(false)"
     (mouseout)="setAutoplayEnabled(true)">
  <div class="carousel-content-container w-100 h-100 d-flex flex-column" khA11yLive [style]="getHeight()">
    <ng-content></ng-content>
  </div>
  <div class="d-flex flex-row justify-content-center my-kh-2 cursor" khA11yTablist>
    <kh-fixed-size-carousel-dot *ngFor="let _ of [].constructor(itemCount); let i = index" [index]="i" [activeIndex]="activeIndex$" (click)="onDotClicked(i)" [dotDiameter]="dotDiameter ?? defaultDotDiameter" [dotActiveColour]="dotActiveColour ?? defaultActiveColour" [dotInactiveColour]="dotInactiveColour ?? defaultInactiveColour">
    </kh-fixed-size-carousel-dot>
  </div>
</div>